import type { ReactElement } from 'react';

import type { PermissionMatrix as Matrix } from '../matrix-presentation';

// Colores de columna por rol (paleta de personas del sistema visual), cíclicos por
// índice, como en el mockup. Presentación pura; no altera el significado.
const ROLE_DOT_COLORS = [
  'var(--person-1)',
  'var(--person-3)',
  'var(--person-4)',
  'var(--person-6)',
  'var(--person-5)',
  'var(--person-2)',
];

/**
 * Matriz rol×capacidad (read-only). Reproduce el sistema visual del mockup
 * (`table.matrix`): filas = capacidades reales agrupadas por área, columnas =
 * roles reales, celda ✓/– según si el rol tiene la capacidad. Scroll horizontal
 * propio en móvil (nunca desborda el body). a11y: `scope` en encabezados.
 */
export function PermissionMatrix({ matrix }: { matrix: Matrix }): ReactElement {
  return (
    <div className="t-scroll">
      <table className="matrix">
        <thead>
          <tr>
            <th className="cap" scope="col">
              Capacidad
            </th>
            {matrix.roles.map((role, i) => (
              <th key={role.code} scope="col">
                <div className="rolehead">
                  <span
                    className="roledot"
                    style={{ background: ROLE_DOT_COLORS[i % ROLE_DOT_COLORS.length] }}
                  />
                  {role.name}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        {matrix.groups.map((group) => (
          <tbody key={group.group}>
            <tr className="grouprow">
              <th className="grouphead" scope="colgroup" colSpan={matrix.roles.length + 1}>
                {group.label}
              </th>
            </tr>
            {group.rows.map((row) => (
              <tr key={row.code}>
                <th className="cap" scope="row">
                  {row.label}
                </th>
                {row.cells.map((cell) => (
                  <td key={cell.roleCode} className={cell.has ? 'yes' : 'no'}>
                    <span aria-hidden="true">{cell.has ? '✓' : '–'}</span>
                    <span className="sr-only">{cell.has ? 'Sí' : 'No'}</span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </div>
  );
}
